export default "__VITE_PUBLIC_ASSET__10266fec__"